import {
  getXmlSection,
  extractMethods,
  extractProperties,
  extractEventsAndTranslations
} from '../utils/xmlParser';

/**
 * TwinCAT file parser service
 */
class TwinCATParserService {
  /**
   * Parse TwinCAT XML content
   * @param {string} xmlString - Raw XML content
   * @returns {Object} - Parsed content object
   */
  parseTwinCAT(xmlString) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

    const declaration = getXmlSection(xmlDoc, 'Declaration');
    const implementation = getXmlSection(xmlDoc, 'Implementation');
    const methods = extractMethods(xmlDoc);
    const properties = extractProperties(xmlDoc);
    const { events, translations } = extractEventsAndTranslations(xmlDoc);

    return {
      xmlString,
      declaration,
      implementation,
      methods,
      properties,
      events,
      translations
    };
  }

  /**
   * Parse generic XML/code content
   * @param {string} xmlString - Raw content
   * @returns {Object}
   */
  parseGeneric(xmlString) {
    return { xmlString };
  }
}

export default TwinCATParserService;
